const json_data = require('./postcode_array.json')
const postcode_region = require('./postcode_region.json')
import { min, max, extent } from 'd3-array'


const data = json_data.map((d) => {
    d.label = `${d.postcode_name}, ${d.postcode}`
    d.postcode_name = d.postcode_name.toLowerCase()
    d.primary_mode = d.primary_mode.toLowerCase()
    d.primary_mode_driving = d.primary_mode_driving.toLowerCase()
    d.avg_pt_time = d.avg_pt_time || 0
    d.region = postcode_region[d.postcode] 
      ? postcode_region[d.postcode].region
      : undefined
    return d
  }).filter(d => d.region)
  // .filter(d => d.postcode !== 2330 && d.postcode !== 2787)

const avg_drive_times = data.map(d => d.avg_drive_time)
const avg_drive_time_min = min(avg_drive_times)
const avg_drive_time_max = max(avg_drive_times)

const avg_pt_times = data.map(d => d.avg_pt_time)
const avg_pt_time_min = min(avg_pt_times)
const avg_pt_time_max = max(avg_pt_times)

const avg_rents = data.map(d => d.avg_rent)
// const avg_rent_min = min(avg_rents)
const avg_rent_min = 0
const avg_rent_max = max(avg_rents)

const avg_rent_real_domain = extent(avg_rents)

const postcode_rankings = data.sort((a, b) => a.avg_pt_time - b.avg_pt_time)
                              .map(d => d.postcode)

export default {
  data,
  avg_drive_time_domain: [avg_drive_time_min, avg_drive_time_max],
  avg_pt_time_domain: [avg_pt_time_min, avg_pt_time_max],
  avg_rent_domain: [avg_rent_min, avg_rent_max],
  avg_rent_real_domain,
  postcode_rankings
}